// Whether to offer "Switch account" in the shell.
//
// Key export: `useCanSwitchRestaurant`.
// Neighbours: `shell/Sidebar.tsx` and `shell/MobileNav.tsx` both read it.
//
// A support or admin agent moves between restaurants all day, so they always get
// it. A merchant gets it only when they belong to more than one team.

import { useTeam } from '@/state/useTeam'
import { useAdminStatus } from '@/state/useAdminStatus'

export function useCanSwitchRestaurant(): boolean {
  const { teams } = useTeam()
  const adminRole = useAdminStatus((s) => s.role)
  return adminRole !== null || teams.length > 1
}
